import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { addDoc, collection, doc, getDoc, Timestamp } from "firebase/firestore";
import Swal from "sweetalert2";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";


function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [systemDetails, setSystemDetails] = useState({});
    const [loading, setLoading] = useState(false);

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });

    useEffect(() => {
        setSystemDetails({
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            language: navigator.language,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });
    }, []);

    const login1 = async () => {
        if (!email || !password) {
            return Toast.fire({
                icon: "error",
                title: "Please enter your email and password",
            });
        }

        setLoading(true);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            const user = auth.currentUser;

            if (user) {
                const docRef = doc(db, "authroles", user.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists() && docSnap.data().role === "Housekeeping") {
                    Toast.fire({ icon: "success", title: "Login Successful!" });

                    await addDoc(collection(db, "logindetails"), {
                        uid: user.uid,
                        username: docSnap.data().name,
                        systemDetails,
                        createdTime: Timestamp.now(),
                    });

                    window.location.href = "/home";
                } else {
                    Toast.fire({ icon: "error", title: "Access Denied" });
                    auth.signOut();
                }
            }
        } catch (error) {
            Toast.fire({ icon: "error", title: "Invalid credentials!" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ height: "100vh", background: "#f5f6fa" }}>
            {/* ========================= HEADER ========================= */}
            <Box
                sx={{
                    height: 80,
                    backdropFilter: "blur(10px)",
                    background: "rgba(255,255,255,0.7)",
                    borderBottom: "1px solid rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 4,
                    position: "sticky",
                    top: 0,
                    zIndex: 20,
                }}
            >
                {/* Left Logo */}
                <Box display="flex" alignItems="center" gap={2}>
                    <img src="/logo.png" height={50} style={{ borderRadius: 5 }} />
                    <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#222" }}>
                        HOTELZIO
                    </Typography>
                </Box>

                {/* Right Section */}
                <Box display="flex" alignItems="center" gap={4}>
                    <Typography sx={{ cursor: "pointer", fontSize: 15, color: "#333" }}>
                        Help
                    </Typography>
                    <Typography sx={{ cursor: "pointer", fontSize: 15, color: "#333" }}>
                        Support
                    </Typography>
                    {/* <Button
                        variant="contained"
                        component={Link}
                        to="/register"
                        sx={{
                            background: "#1a73e8",
                            borderRadius: 10,
                            textTransform: "none",
                            px: 3,
                            "&:hover": { background: "#1669c1" },
                        }}
                    >
                        Sign Up
                    </Button> */}
                </Box>
            </Box>



            {/* ========================= LOGIN BOX ========================= */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="calc(100vh - 70px)"
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: 400,
                        p: 4,
                        borderRadius: 3,
                        background: "#fff",
                    }}
                >
                    <Typography variant="h5" textAlign="center" fontWeight="bold" mb={2}>
                        Welcome Back
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="center"
                        sx={{ mb: 3, color: "#555" }}
                    >
                        Sign in to access your dashboard
                    </Typography>

                    <TextField
                        fullWidth
                        size="small"
                        label="Email Address"
                        sx={{ mb: 2 }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        size="small"
                        label="Password"
                        type="password"
                        sx={{ mb: 3 }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <Button
                        variant="contained"
                        fullWidth
                        onClick={login1}
                        disabled={loading}
                        sx={{
                            py: 1.2,
                            background: "#1a73e8",
                            fontWeight: "bold",
                            textTransform: "none",
                            "&:hover": { background: "#1669c1" },
                        }}
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Sign In"
                        )}
                    </Button>

                    <Typography
                        variant="caption"
                        display="block"
                        textAlign="center"
                        sx={{ mt: 4, color: "#777" }}
                    >
                        © {new Date().getFullYear()} HotelZio
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
}

export default Login;
